import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import "./PasswordInput.scss";

export function PasswordInput({ label, ...props }) {
  const [showPassword, setShowPassword] = useState(false);
  const buttonAriaLabel = showPassword ? "Fsheh fjalekalimin" : "Shfaq fjalekalimin";
  const externalInputProps = props.InputProps || {};
  const { endAdornment: externalEndAdornment, ...restExternalInputProps } = externalInputProps;

  return (
    <div className="password-input">
      <TextField
        type={showPassword ? "text" : "password"}
        label={label}
        variant="filled"
        fullWidth
        className="password-input__field"
        {...props}
        inputProps={{
          ...(props.inputProps || {}),
          autoComplete: props.autoComplete || "off",
        }}
        InputProps={{
          ...restExternalInputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                aria-label={buttonAriaLabel}
                title={buttonAriaLabel}
                className="password-input__toggle"
                size="small"
              >
                {showPassword ? (
                  <EyeOff className="password-input__icon" />
                ) : (
                  <Eye className="password-input__icon" />
                )}
              </IconButton>
              {externalEndAdornment}
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}